export const environment = {
  production: false,
  defaultauth: "fackbackend",

  hereApiKey: "KveI3PiZekt1av1z4UUj60CARM5E7CBNepJLv4RUZo0",

  //DEV
  //apiBaseAddress: "http://localhost:5000/api/",

  //QA
  //apiBaseAddress:
  //  "https://wkftracker-qa-api-bhg6g5dee2eue0gv.centralus-01.azurewebsites.net/api/",

  //HOMOLOG
  //apiBaseAddress: "https://tracker-homolog-api.workfinity.com.br/api/",

  //PSPROD
  //apiBaseAddress: "https://pstracker-api.workfinity.com.br/api/",

  //PROD
  apiBaseAddress: "https://tracker-api.workfinity.com.br/api/",

  //OGEA
  //apiBaseAddress: "https://ogwkftracker-api.azurewebsites.net/api/",

  viewTenantCode: true, //False para esconder o tenantCode no login em ambientes customizados

  version: "1.7.7.1",
};

export const custom = {
  //Default
  logo_login: null,
  codeTenant: null,

  //PagResolve
  //logo_login: 'https://isolutions.s3.us-east-1.amazonaws.com/workfinitytracker/pagresolve/logo_pag_resolve_login.png',
  //codeTenant: 'PAG_RESOLVE',

  //ÓGEA
  // logo_login: "https://s3.amazonaws.com/AvatekStorage/ogea_small.png",
  // codeTenant: "OGEA",
};
